export { default as DoubleRangeSlider } from './DoubleRangeSlider';
export * from './types';
